import React from 'react';
import PickMeals from '../assets/pick-meals-image.png';
import DeliveryMeals from '../assets/choose-image.png';
import ChooseMeals from '../assets/delivery-image.png';

const Work = () => {
    const workInfoData = [
          {
            image: PickMeals,
            title: "Browse Restaurants",
            text: "Explore a variety of restaurants, discover delicious meals, and choose your favorite dishes with just a few taps."
          },
          {
            image: ChooseMeals,
            title: "Place Your Order",
            text: "Customize your meal, add it to your cart, and complete your order quickly with a smooth checkout experience."
          },
          {
            image: DeliveryMeals,
            title: "Fast Delivery",
            text: "Sit back and relax while CraveOn delivers your food hot, fresh, and right to your doorstep in no time."
          },
    ];
  return (
    <div className='work-section-wrapper' id="hiw">
      <div className='work-section-top'>
        <p className='primary-subheading'>Work</p>
        <h1 className='primary-heading'>How It Works</h1>
        <p className='primary-text'>
            Browse restaurants, pick your favorite dishes, place your order, and let CraveOn deliver fresh, delicious food straight to your door in just a few simple steps.
        </p>
      </div>
      <div className='work-section-bottom'>
        {
            workInfoData.map((data) => (
                <div className='work-section-info' key={data.title}>
                    <div className='info-boxes-img-container'>
                        <img src={data.image} alt={data.title}/>
                    </div>
                    <h2>{data.title}</h2>
                    <p>{data.text}</p>
                </div>
            ))
        }
      </div>
    </div>
  )
}

export default Work
